import React from "react";
import ResourceTable from "./ResourceTable";
import { POINTS_ADMIN } from "../../config/lang";
import { translate } from "../../util/util";

export default function ResourceList({ descriptor, currentUser, history }) {
  return (
    <div className="container-fluid">
      <div className="box p-4">
        <h2 className="pt-list-title">{translate(POINTS_ADMIN, descriptor.titleKey, currentUser.language)}</h2>
        <ResourceTable
          descriptor={descriptor}
          currentUser={currentUser}
          onOpen={id => history.push(
            id === "new"
              ? (descriptor.newPath || `/${descriptor.slug}/new`)
              : (descriptor.detailPath ? descriptor.detailPath(id) : `/${descriptor.slug}/${id}`)
          )}
        />
      </div>
    </div>
  );
}
